import { createUseFetchSearchWithCustomPropsFn } from '@common/search.services';
import { IPagedResultsV1 } from '@gcl/react-core';
import { FETCH_QUERIES_NAME, MUTATION_KEYS } from '@common/constants';
import { useMutation } from '@tanstack/react-query';
import { AxiosErrorResponse } from '@core/error.models';
import { IAnnouncementSearchResult } from './announcement.models';
import { postAnnouncementNonExpiredAsync, searchAnnouncementAsync } from './announcement.services';

export const useFetchAnnouncementSearch = createUseFetchSearchWithCustomPropsFn<
  {},
  IPagedResultsV1<IAnnouncementSearchResult>
>({
  queryName: FETCH_QUERIES_NAME.ANNOUNCEMENT_SEARCH,
  searchAsyncFn: searchAnnouncementAsync,
});

export const useGetAnnouncementNonExpired = () => {
  return useMutation<number[] | undefined, AxiosErrorResponse>(
    [MUTATION_KEYS.GET_ANNOUNCEMENT_NON_EXPIRED],
    async () => {
      const result = await postAnnouncementNonExpiredAsync();
      return result.items;
    },
  );
};
